import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import awsConfig from './aws-exports';

// デバッグ用：Amplify設定確認
console.log('🔍 Index.tsx - Environment Check:', {
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_COGNITO_USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  REACT_APP_COGNITO_APP_CLIENT_ID: process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
  timestamp: new Date().toISOString()
});

// AWS Amplify設定（require使用）
const configureAmplify = async () => {
  try {
    // @ts-ignore
    const Amplify = require('aws-amplify').Amplify;
    Amplify.configure(awsConfig);
  } catch (error) {
    console.error('Error configuring Amplify:', error);
  }
};

// Amplify設定を実行
configureAmplify();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// パフォーマンス測定（オプション）
reportWebVitals(); 